import React from 'react';

export const LeftCard: React.FC<{
  backgroundImage: string;
  logo?: React.ReactNode;
  title?: string;
  subtitle?: string;
  /**
   * Adds a dark top-to-bottom gradient scrim over the background image, for
   * photos that don't have enough natural contrast for a light logo/title.
   */
  overlay?: boolean;
}> = ({ backgroundImage, logo, title, subtitle, overlay }) => {
  return (
    <>
      <div
        className="relative hidden h-full flex-col p-10 text-white dark:border-r lg:flex filter brightness-75 bg-center"
        style={{
          background: `url(${backgroundImage})`,
          backgroundSize: 'cover',
        }}
      >
        {overlay && (
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/20 to-transparent" />
        )}
      </div>
      <div className="fixed hidden lg:flex lg:flex-col lg:gap-6 lg:max-w-[40vw] top-10 left-8">
        <div>{logo}</div>
        {title && (
          <div className="text-background text-5xl font-semibold">{title}</div>
        )}
        {subtitle && (
          <div className="text-background text-base font-medium mt-4">
            {subtitle}
          </div>
        )}
      </div>
    </>
  );
};
